module.exports = __webpack_public_path__ + "img/partnership_process_04.19a82395.png";